import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import AlertDialog from '../../components/Dialog/alertDialog';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IfacilitiesCategoriesStore,
} from '../../mobx-store/storeInterfaces/facilitiesCategoriesInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import queryString from 'query-string';
import { facilityTypes } from '../facilitiesMangementScreen/facilities';
import { languageCodes } from '../../constants/languages';

interface IProps extends WithSnackbarProps {
  facilitiesCategoriesStore: IfacilitiesCategoriesStore;
  countryStore: CountryStore;
  history: any;
  match: any;
  location: any;
}

interface IState {
  open: boolean;
}

@inject('facilitiesCategoriesStore')
@inject('countryStore')
@observer
class FacilitiesCategories extends Component<IProps, IState> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  facilityCategoryType: string;

  handleAgree: () => void = () => null;

  constructor(props: IProps) {
    super(props);
    this.title = translate('facilitiesCategoriesListPageTitle', {
    });
    this.state = {
      open: false,
    };
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/facilities-categories/${this.props.facilitiesCategoriesStore.categoriesList[index].facilityCategoryId}/edit?type=${this.facilityCategoryType}`);
  };

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    if (!value) {
      this.handleAgree = () => {
        this.props.facilitiesCategoriesStore.updateFacilityCategoryStatus(false, index)
          .then(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 8000, 'success');
          })
          .catch((error: any) => {
            SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 8000, 'error');
          });
        this.setState({
          open: false,
        });
      };
      this.handleClickOpen();
    } else {
      this.props.facilitiesCategoriesStore.updateFacilityCategoryStatus(true, index)
        .then(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
        })
        .catch((error: any) => {
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    }
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleAdd = (): void => {
    this.props.history.push(`/facilities-categories/new?type=${this.facilityCategoryType}`);
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  getAddCategoryButton = () => ({
    title: translate('facilitiesCategoriesListAddButton', {
    }),
    onAdd: this.handleAdd,
  });

  getCategoriesTableHeader = () => {
    const tableHeaders = [
      {
        title: translate('facilitiesCategoriesListTitleColumnTitle', {
        }),
      },
      {
        title: translate('facilitiesCategoriesListStatusColumnTitle', {
        }),
      },
      {
        title: translate('facilitiesCategoriesListEditColumnTitle', {
        }),
      },
    ];

    const facilityType = this.getQueryParam();
    if (facilityType === facilityTypes.RATING) {
      tableHeaders.push({
        title: 'Edit Form',
      },);
    }

    return tableHeaders;

  };

  getCategoriesTableData = () => this.props.facilitiesCategoriesStore.categoriesList
    .map((category) => ({
      ...category, edit: 'Edit',
    }));

  handleEditForm = (index: number, key: string): void => {
    localStorage.setItem('parentRoute', '/facilities-categories?type=RATING');
    this.props.history.push({
      pathname: `/facilities-form/${this.props.facilitiesCategoriesStore.categoriesList[index].defaultQuestionsForm?.questionsFormId}/edit`,
    });
  };

  getCategoriesTableCellTypes = (): TableCellTypes[] => {
    const cellTypes: TableCellTypes[] = [
      {
        cellType: 'Text',
        key: 'title',
      },
      {
        cellType: 'ToggleButton',
        key: 'isActive',
        activeLabel: translate('facilitiesCategoriesListStatusActive', {
        }),
        inactiveLabel: translate('facilitiesCategoriesListStatusInActive', {
        }),
        onChange: this.handleTableToggleCellChange,
      },
      {
        cellType: 'Button',
        key: 'edit',
        onClick: this.handleTableButtonCellClicked,
      },
    ];

    const facilityType = this.getQueryParam();
    if (facilityType === facilityTypes.RATING) {
      cellTypes.push({
        cellType: 'Button',
        key: 'editForm',
        onClick: this.handleEditForm,
      });
    }

    return cellTypes;
  };

  returnTableData = () => {
    this.addButton = this.getAddCategoryButton();
    this.tableHeader = this.getCategoriesTableHeader();
    this.tableData = this.getCategoriesTableData();
    this.tableCellTypes = this.getCategoriesTableCellTypes();
  };

  render() {
    this.returnTableData();
    return (
      <div>
        <div>
          <GeneralTableComponent
            emptyMessage={translate('facilitiesCategoriesListNoCategoriesMessage', {
            })}
            title={this.title}
            tableHeader={this.tableHeader}
            tableData={this.tableData}
            tableCellTypes={this.tableCellTypes}
            addButton={this.addButton}
            loadingStatus={[
              this.props.facilitiesCategoriesStore.getFacilitiesCategoriesRequestStatus,
              this.props.countryStore.getManagedCountriesRequestStatus
            ]}
          />
        </div>
        <div>
          <AlertDialog
            title="Wadi Degla Dashboard"
            content={translate('facilitiesCategoriesListDeactivationWarning', {
            })}
            isOpen={this.state.open}
            agree={this.handleAgree}
            disAgree={this.handleClose}
            hasActions
          />
        </div>
      </div>
    );
  }

  getQueryParam = () => {
    const queryValues = queryString.parse(this.props.location.search);
    const facilityTypeToCall: any = (queryValues.type) ? queryValues.type : facilityTypes.ALL;

    return facilityTypeToCall;
  }

  async componentDidMount() {
    const {
      countryStore, facilitiesCategoriesStore,
    } = this.props;

    this.facilityCategoryType = this.getQueryParam();

    await countryStore.getUserManagedCountries();
    facilitiesCategoriesStore.getFacilityCategories(countryStore.managedCountries, this.facilityCategoryType, languageCodes.english);
  }
}

export default FacilitiesCategories;
